import routerWithSidebar from "./routerWithSidebar";

export default {
  path: "/weekly",
  component: () =>
    import(/* webpackChunkName: "SidebarLayout" */ "@/layout/SidebarLayout/index.vue"),
  children: [
    {
      path: "/weekly",
      name: "weekly",
      components: routerWithSidebar(() =>
        import(/* webpackChunkName: "role" */ "@/views/week/index.vue")
      ),
      children: [
        {
          path: "/weekly/writeWeekly",
          name: "writeWeekly",
          components: routerWithSidebar(() =>
            import(/* webpackChunkName: "role" */ "@/views/week/writeWeekly.vue")
          )
        },
        {
          path: "/weekly",
          name: "weekly",
          components: routerWithSidebar(() =>
            import(/* webpackChunkName: "role" */ "@/views/week/readWeekly.vue")
          )
        }
      ]
    }
  ]
};
